import {
    DeleteImageIconButton,
    ImageOverlay,
    UploadIndicator,
    RetryButton,
    RetryIndicator,
} from "../../PostForm.styles";
import { useContext } from "react";
import { SortableItemContext } from "../../../../SortableList/SortableItem";
import { ImageItemType } from "../../PostFormModal.types";
import { ImageItemContainer, ImageItemPreview } from "./ImagesOptions.styles";
import { CloseIcon } from "@icons/CloseIcon";

export function ImageItem({
    image,
    itemKey,
    handleOnRemoveImage,
    handleImageUploadRetry,
    allowPollEdit,
}: ImageItemType & { allowPollEdit: boolean }) {
    const { attributes, listeners, ref } = useContext(SortableItemContext);
    const imageUrl =
        image.mediaType === "video" ? image.videoThumbnailUrl : image.imageUrl;
    return (
        <ImageItemContainer>
            {allowPollEdit && (
                <DeleteImageIconButton
                    disabled={image.isUploading}
                    children={<CloseIcon />}
                    onClick={() => {
                        handleOnRemoveImage(itemKey - 1);
                    }}
                />
            )}
            <ImageItemPreview
                image={imageUrl ?? undefined}
                {...attributes}
                {...listeners}
                ref={ref}
            />
            {image.isUploading && (
                <ImageOverlay>
                    <UploadIndicator
                        style={{ width: "36px", height: "36px" }}
                    />
                </ImageOverlay>
            )}
            {image.failed && (
                <ImageOverlay>
                    <RetryButton
                        onClick={() => {
                            handleImageUploadRetry(image);
                        }}
                        style={{ width: "36px", height: "36px" }}
                    >
                        <RetryIndicator />
                    </RetryButton>
                </ImageOverlay>
            )}
        </ImageItemContainer>
    );
}
